import * as React from 'react';
import {useContext, useEffect, useState} from 'react';
import {DefaultButton, Dropdown, Panel, PrimaryButton, Stack, TextField} from '@fluentui/react';
import AuthContext from "../../Services/AuthContext";
import validateForm from "../../Utilities/validateForm";
import ventureStates  from '../../Utilities/Const/ventureStates'

function EditVenture(props) {
    const [user] = useContext(AuthContext);
    const [name, setName] = useState('');
    const [buffer, setBuffer] = useState('');
    const [series, setSeries] = useState('');
    const [company, setCompany] = useState(null);
    const [companies, setCompanies] = useState([]);
    const [city, setCity] = useState('');
    const [postal, setPostal] = useState('');
    const [address, setAddress] = useState('');
    const [identification, setIdentification] = useState('');
    const [description, setDescription] = useState('');
    const [formErrors, setFormErrors] = useState([])
    const statusOptions = Object.entries(ventureStates).map(([key, value]) => ({ key: parseInt(key), text: value }))
    const [status, setStatus] = useState('')

    const _submit = (e) => {
        e.preventDefault();
        const data = {name: name, buffer_account: buffer, series: series, city: city, postal_code: postal,
            address: address, company_id: company?.key, identification: identification, description: description, status: status};
        if (validateForm(data, ['company_id', 'name', 'buffer_account', 'series', 'status'], setFormErrors)) {
            fetch(`/api/venture/${props.edit.id}`, {
                method: 'PUT',
                body: JSON.stringify(data),
                headers: {
                    'Authorization': 'Bearer ' + user.token
                }
            }).then(res => res.json())
                .then(json => {
                    props.onSuccess(json);
                    props.dismissPanel();
                })
                .catch(err => {
                    console.log(err)
                })
        }
    }

    const footer = React.useCallback(() => (<Stack horizontal horizontalAlign='space-between'>
        <PrimaryButton type='submit' form='EditVenture'>Edytuj</PrimaryButton>
        <DefaultButton onClick={props.dismissPanel}>Anuluj</DefaultButton>
    </Stack>), [props.dismissPanel]);


    useEffect(() => {
        const abortController = new AbortController();
        setName(props.edit?.name || '');
        setBuffer(props.edit?.buffer_account || '');
        setSeries(props.edit?.series || '');
        setCompany({key: props.edit?.company_id || ''});
        setCity(props.edit?.city || '');
        setPostal(props.edit?.postal_code || '');
        setAddress(props.edit?.address || '');
        setIdentification(props.edit?.identification || '');
        setDescription(props.edit?.description || '');
        setStatus(props.edit?.status);

        async function fetchCompanies() {
            const abortController = new AbortController();
            await fetch(`/api/company`, {
                method: 'GET',
                signal: abortController.signal,
                headers: {
                    'Authorization': 'Bearer ' + user.token
                }
            }).then(res => res.json())
                .then(data => {
                    setCompanies(data.map((item) => {
                        return {key: item.id, text: item.name};
                    }))
                })
                .catch(err => {
                    console.log(err)
                })
        }
        fetchCompanies();
        return () => abortController.abort();
    }, [props.edit, user.token])


    return (
        <Panel
            isOpen={props.edit}
            onDismiss={props.dismissPanel}
            headerText="Edytuj Kontrakt"
            closeButtonAriaLabel="Close"
            onRenderFooterContent={footer}
            isFooterAtBottom={true}
        >
            <p>{props.edit?.keystring}</p>
            <form onSubmit={_submit} id='EditVenture'>
                <Dropdown
                    label={"Status"}
                    selectedKey={status}
                    onChange={(e, item) => setStatus(item.key)}
                    options={statusOptions}
                    required
                    errorMessage={formErrors['status']}
                />
                <Dropdown
                    label="Firma"
                    selectedKey={company ? company.key : undefined}
                    onChange={(e, item) => setCompany(item)}
                    placeholder="Wybierz z listy"
                    options={companies}
                    required
                    errorMessage={formErrors['company_id']}
                />
                <TextField required autoFocus label='Nazwa' value={name} onChange={(e) => setName(e.target.value || '')}/>
                <TextField required label='Konto' value={buffer} onChange={(e) => setBuffer(e.target.value || '')}/>
                <TextField required label='Seria Dokumentów' value={series} onChange={(e) => setSeries(e.target.value || '')}/>
                <TextField label='Miasto' value={city} onChange={(e) => setCity(e.target.value || '')}/>
                <TextField label='Kod pocztowy' value={postal} onChange={(e) => setPostal(e.target.value || '')}/>
                <TextField label='Adres' value={address} onChange={(e) => setAddress(e.target.value || '')}/>
                <TextField label='Numer identyfikacyjny' value={identification} onChange={(e) => setIdentification(e.target.value || '')} maxLength={90} />
                <TextField label='Opis' value={description} onChange={(e) => setDescription(e.target.value || '')} maxLength={255} multiline/>
            </form>
        </Panel>
    )
}

export default EditVenture;